<template>
  <v-app>
    <v-toolbar height="80px" class="px-1">
      <img :src="logo" height="55px" />
      <v-spacer></v-spacer>
      <v-btn flat @click="setLanguage(locale)" class="min-width-0 mx-1" v-for="(locale) in $settings.locales" :key="locale" :color="activeColor(locale)">{{ locale }}</v-btn>
    </v-toolbar>
    <v-content>
      <v-container grid-list-lg>
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      title: "TTP",
      locale: this.$i18n.locale,
    };
  },
  methods: {
    setLanguage(code) {
      this.$i18n.locale = code;
      document.title = this.$i18n.t(this.$route.meta.title).name;
    },
    activeColor(code) {
      if (this.$i18n.locale == code) return "";
      else return "grey";
    }
  },
  computed: {
    logo() {
      return (
        // TODO " + this.project.name + "
        "projects/ttp-dzhk/logo_" + this.$i18n.locale + ".png"
      );
    }
  }
};
</script>

<style>
.pre-line-break {
  white-space: pre-line;
  height: auto;
}
.min-width-0 {
  min-width: 0;
}
.v-chip {
  font-size: 14px;
}
</style>